<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-title text="Rondas Realizadas"></app-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-rounds-report-filters
                    @filter="onFilter"
                ></app-rounds-report-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-rounds-report-list
                    :rounds-data="roundsData"
                    @changePage="onChangePage"
                    @show-checkpoints="onShowCheckpoints"
                    @sort="onSort"
                ></app-rounds-report-list>
            </b-col>
        </b-row>
        <app-pop-up
            v-if="!!selectedRound"
            id="checkpoints-window"
            :title="
                `${selectedRound.round.client.name} - ${selectedRound.round.name}`
            "
            size="large"
        >
            <template slot="body">
                <b-row>
                    <b-col>
                        <GmapMap
                            :center="center"
                            :options="mapOptions"
                            :zoom="18"
                            style="width: 100%; max-width: 100%; height: 350px"
                        >
                            <GmapMarker
                                :key="index"
                                v-for="(m, index) in markers"
                                :position="m.position"
                                :clickable="true"
                                :draggable="true"
                                @click="center = m.position"
                                :label="m.label"
                            />
                        </GmapMap>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-data-table
                            :fields="checkpointTableFields"
                            :items="markers"
                        ></app-data-table>
                    </b-col>
                </b-row>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import roundsRepository from '@repositories/rounds.repository'
import moment from 'moment'
import RoundsReportFilters from './RoundsReportFilters'
import RoundsReportList from './RoundsReportList'
export default {
    components: {
        appRoundsReportFilters: RoundsReportFilters,
        appRoundsReportList: RoundsReportList,
    },
    data: () => ({
        roundsData: null,
        filters: '',
        page: 1,
        sortBy: 'start_date',
        sortDir: 'desc',
        selectedRound: '',
        checkPoints: [],
        checkpointTableFields,
        center,
        mapOptions,
    }),
    computed: {
        markers() {
            return this.checkPoints.map((item, idx) => ({
                position: {
                    lat: parseFloat(item.latitude),
                    lng: parseFloat(item.longitude),
                },
                label: `${idx + 1}`,
                name: item.round_control_point.name,
                date: item.checkpoint_date,
            }))
        },
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadRounds()
        },
        async loadRounds() {
            const rr = { ...roundsRepository }
            try {
                const theFilters = !!this.user.profile.client_side
                    ? { ...this.filters, clientId: this.client.id }
                    : this.filters
                const params = {
                    ...theFilters,
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                }
                const { data } = await rr.getInstances(params)
                const _data = data.data.map(item => ({
                    ...item,
                    start_date: !!item.start_date
                        ? moment(item.start_date).format('DD/MM/YYYY HH:mm:ss')
                        : '',
                    end_date: !!item.end_date
                        ? moment(item.end_date).format('DD/MM/YYYY HH:mm:ss')
                        : '',
                }))
                data.data = _data
                this.roundsData = data
            } catch (error) {
                this.handleErrors(error)
            }
        },
        onChangePage(page) {
            this.page = page
            this.loadRounds()
        },
        onShowCheckpoints(roundInstance) {
            this.selectedRound = roundInstance
            this.$nextTick(() => {
                this.$bus.$emit('checkpoints-window.open')
            })
            this.loadCheckpoints(roundInstance.id)
        },
        async loadCheckpoints(id) {
            const rr = { ...roundsRepository }
            try {
                const { data } = await rr.getCheckpoints(id)
                this.checkPoints = data
                this.$nextTick(() => {
                    if (this.markers.length) {
                        this.center = this.markers[0].position
                    }
                })
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.onFilter()
        },
    },
    mounted() {
        this.loadRounds()
    },
}

const checkpointTableFields = [
    {
        key: 'label',
        label: '#',
    },
    {
        key: 'name',
        label: 'Punto de control',
    },
    {
        key: 'date',
        label: 'Fecha punto de control',
    },
    {
        key: 'position.lat',
        label: 'Latitud',
    },
    {
        key: 'position.lng',
        label: 'Longitud',
    },
]
const center = {
    lat: 0,
    lng: 0,
}
const mapOptions = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true,
    disableDefaultUi: false,
}
</script>
